import { Transaction } from 'types';

const baseSocietyUrl = `/transacciones`;
const baseDetailsUrl = `/detalle-transacciones`;

export const getTransactionDetailsUrl = (
  transaction: Pick<Transaction, '_id' | 'operation' | 'society'>
) => {
  const { operation, society } = transaction;

  if (!transaction || !society) {
    return null;
  }

  const transactionId = operation;

  if (!transactionId) {
    return `${baseSocietyUrl}/${society}`;
  }

  return `${baseDetailsUrl}/${society}/${transactionId}`;
};
